import { httpService as a } from "@waitroom/http-client";
import { config as o } from "../config.es.js";
import { buildApiParamsWithAuth as i, buildApiParams as e } from "../helpers.es.js";
const n = "/auth", h = {
  verifyOTP: async (t) => a.post(await e("/auth/verify-otp", t)),
  verifyOAuthOTP: async (t) => a.post(await e("/oauth/verify-otp", t)),
  requestOTP: async (t) => a.post(
    await e("/auth/request-otp", {
      ...t,
      data: {
        ...t.data,
        fingerprint: await o.getFingerPrint
      }
    })
  ),
  requestOAuthOTP: async (t) => a.post(
    await e("/oauth/request-otp", {
      ...t,
      data: {
        ...t.data,
        fingerprint: await o.getFingerPrint
      }
    })
  ),
  verifyAuthTokenProvider: async (t) => a.post(await e("/auth/social-token", t)),
  verifyOAuthTokenProvider: async (t) => a.post(await e("/oauth/social-token", t)),
  verifyAuthCodeProvider: async (t) => a.post(await e("/auth/social-code", t)),
  verifyOAuthCodeProvider: async (t) => a.post(await e("/oauth/social-code", t)),
  refreshToken: async (t) => a.put(await e("/auth/refresh-auth-token", t)),
  logout: async (t) => a.post(await i("/auth/logout", t)),
  hostOptIn: async () => a.patch(await i("/auth/user/host-opt-in")),
  user: async (t) => a.get(await i("/auth/user", t)),
  registerGuest: async (t) => a.post(await i("/auth/guest", t))
};
export {
  h as authApiService,
  n as authBaseEndpoint
};
